import type { SoundEffectDto } from '../../data/sound-effect.dto'
import type { SoundEffect } from '../models/sound-effect'

export const mapSoundEffectDtoToSoundEffect = ({
  name,
  alias,
  duration_sec: duration,
  description,
  url,
}: SoundEffectDto): SoundEffect => ({
  id: alias,
  name: name.replace(/_/g, ' '),
  duration,
  description,
  url,
})
